// Reaching the user when they are not looking at this page.
//
// A deep analysis takes 8–10 minutes, so by the time it lands the user is
// usually on another page or another browser tab. Two channels cover that:
// a flashing document title (works everywhere, no permission) and a desktop
// notification (works when the whole browser is in the background).

let stopCurrentFlash = null;

/** Stops the title flash and puts the original title back. */
export function stopTitleFlash() {
  if (stopCurrentFlash) stopCurrentFlash();
}

/** Alternates the browser tab title with `text` until the user comes back. */
export function flashTitle(text) {
  if (typeof document === "undefined") return;
  stopTitleFlash();

  const original = document.title;
  let showingAlert = false;

  const timer = setInterval(() => {
    showingAlert = !showingAlert;
    document.title = showingAlert ? text : original;
  }, 1200);

  const onVisible = () => {
    if (!document.hidden) stopTitleFlash();
  };
  document.addEventListener("visibilitychange", onVisible);

  stopCurrentFlash = () => {
    clearInterval(timer);
    document.removeEventListener("visibilitychange", onVisible);
    // Helmet may have set a new title meanwhile — only undo our own.
    if (document.title === text) document.title = original;
    stopCurrentFlash = null;
  };
}

/**
 * Asks for desktop-notification permission.
 * Called when the user starts a run, never on page load — a prompt out of
 * nowhere gets denied, and a denial is permanent.
 */
export function askNotifyPermission() {
  if (typeof Notification === "undefined") return;
  if (Notification.permission !== "default") return;
  try {
    const asked = Notification.requestPermission();
    if (asked && typeof asked.catch === "function") asked.catch(() => {});
  } catch {
    // older browsers use the callback form — not worth a shim
  }
}

/** Desktop notification. Silently does nothing without permission. */
export function nativeNotify({ title, body, onClick }) {
  if (typeof Notification === "undefined") return;
  if (Notification.permission !== "granted") return;

  try {
    const note = new Notification(title, {
      body,
      tag: "money-deep-analysis", // replaces, never stacks
      icon: "/favicon.png",
    });
    note.onclick = () => {
      window.focus();
      note.close();
      if (onClick) onClick();
    };
  } catch {
    // some browsers only allow this from a service worker
  }
}
